import { defineMessages } from 'react-intl';

const messages = defineMessages({
  est_map_info1: {
    id: 'C5Qakw',
    defaultMessage: 'Includes 1 map',
  },
  std_notif_txt: {
    id: '9pLB+Z',
    defaultMessage: 'Take me to Standard',
  },
  feat_label: {
    id: 'ZXp0z1',
    defaultMessage: 'Features',
  },
  est_map_info2: {
    id: 'dA+Mw0',
    defaultMessage: '- can add up to 300 total maps',
  },
  slider1_text: {
    id: 'djSJ9G',
    defaultMessage: 'Total number of direct connections',
  },
  tooltip_document_text: {
    id: 'J8viMk',
    defaultMessage:
      'Enter the total number of documents in thousands you want to exchange between your organization and your customers, suppliers, distributors and other trading partners each 12 months.',
  },
  est_feat_pt1: {
    id: 'HozEqX',
    defaultMessage: 'Includes IBM Stering B2B Integration VAN',
  },
  std_feat_pt3: {
    id: 'LNa+wb',
    defaultMessage: 'Real-time web services, processing and data enrichment',
  },
  std_feat_pt4: {
    id: 'ynp3Ve',
    defaultMessage: 'Complex business rules/routing, pre and post-processing',
  },
  disclaimer_text: {
    id: 'TBFfML',
    defaultMessage:
      'Calculated prices are estimates provided for planning purposes only taking into account potential IBM discounts, and are not a formal offer from IBM or an IBM Business Partner. The estimation may reflect the total discounted price. Certain factors such as configuration, add-ons, or additional requirements will affect final price. IBM Business Partners set and provide their own IBM Sterling B2B Integration pricing, and neither IBM nor IBM Business Partners are bound by the provided estimate.',
  },
  est_feat_pt3: {
    id: 'zaU+Wp',
    defaultMessage: 'Comprehensive track and trace visibility',
  },
  std_feat_pt1: {
    id: '8CdDhv',
    defaultMessage: 'AI-enhanced anomaly detection and natural language search',
  },
  tooltip_connection_text: {
    id: 'rYd61t',
    defaultMessage:
      'Enter the number of connections you want to establish between your organization and the total number of customers, suppliers, distributors, or other trading partners.',
  },
  est_feat_pt2: {
    id: 'lsaNNj',
    defaultMessage: 'Secure protocol-based document routing and delivery',
  },
  std_feat_pt2: {
    id: 'VeG/L/',
    defaultMessage:
      'Self-serve management for common configuration capabilities',
  },
  est_feat_pt5: {
    id: 'zVvX9Z',
    defaultMessage: 'Support for industry and technical standards',
  },
  est_feat_pt4: {
    id: '9NY6Ii',
    defaultMessage:
      'Data transformation and mapping functionality on the cloud',
  },
  estimated_text: {
    id: 'g2aQHN',
    defaultMessage: 'Estimated cost first year',
  },
  slider3_text: {
    id: 'UVa6Vm',
    defaultMessage: 'Total number of documents / year',
  },
  std_label: {
    id: 'cb2kY6',
    defaultMessage: 'Standard',
  },
  prem_label: {
    id: 'C5xzTC',
    defaultMessage: 'Premium',
  },
  map_invalid_text: {
    id: 'ULdgyo',
    defaultMessage: 'Please provide a Maps calls range between 1 - 300',
  },
  est_tile_desc: {
    id: 'WtU+PZ',
    defaultMessage:
      'Securely exchange B2B and B2G data with key customers, distributors or suppliers using any EDI format or APIs. New attractive prices can get you started with just 1 connection and the ability to expand at any time.',
  },
  col1_text: {
    id: 'FCjGve',
    defaultMessage: 'Requirement',
  },
  note_label: {
    id: 'qMePPG',
    defaultMessage: 'Note',
  },
  sterling_sub_headline: {
    id: 'Op2q5m',
    defaultMessage:
      'Estimate your IBM Sterling B2B Integration SaaS price or request a price quote',
  },
  thank_you: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  key2_text: {
    id: 'EFWGgA',
    defaultMessage: 'Maps',
  },
  prem_notif_label: {
    id: 'vt9nHB',
    defaultMessage: 'Information notification',
  },
  tooltip_map_text: {
    id: 'HbgqTq',
    defaultMessage:
      'Enter the total number of maps (translations) you need.  A map is the process of taking structured data from one EDI format and translating it into another EDI or structured data format.',
  },
  return_est_text: {
    id: 'lwF2PS',
    defaultMessage: 'Return to the pricing page',
  },
  prcie_text: {
    id: 'cVxiy4',
    defaultMessage: 'Prices shown do not include tax',
  },
  bp_desc: {
    id: '9k14Pe',
    defaultMessage:
      'I consent to IBM providing my business contact information: ',
  },
  key1_text: {
    id: 'l9CREU',
    defaultMessage: 'Connections',
  },
  contact_info: {
    id: 'ic57NA',
    defaultMessage:
      'For more information regarding this offering and industry solutions please get in touch with us.',
  },
  close_btn_text: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  est_label: {
    id: 'eXbuB9',
    defaultMessage: 'Essentials',
  },
  prem_tag_1: {
    id: 'u9bpan',
    defaultMessage: 'Designated IBM project executive',
  },
  std_tile_desc: {
    id: 'CgCNia',
    defaultMessage:
      'Meet your partners’ complex data format and standards requirements. The Standard edition offers the ability to configure document mapping/transformation in the cloud, including   some self-service capabilities',
  },
  recommend_text_std: {
    id: '9CHAKN',
    defaultMessage: 'Based on your input we recommend the next tier',
  },
  est_conn_info2: {
    id: 'rLDWk4',
    defaultMessage: '- can add up to 50 total connections',
  },
  est_conn_info1: {
    id: 'LE4Wpl',
    defaultMessage: 'Includes 1 connection',
  },
  est_doc_info2: {
    id: 'vFIvpH',
    defaultMessage: '- can add up to 100,000 total documents',
  },
  est_doc_info1: {
    id: 'lkmlH1',
    defaultMessage: 'Includes 4000 documents / year',
  },
  prem_tag_3: {
    id: 'BpO7qL',
    defaultMessage: 'Option to have IBM directly support your trading partners',
  },
  prem_tag_2: {
    id: 'mT0l4O',
    defaultMessage:
      'Managed service with proactive document flow monitoring and error resolution',
  },
  quote_text: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  req_detail: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  key3_text: {
    id: '+vPapi',
    defaultMessage: 'Documents / year',
  },
  package_label: {
    id: 'RcNFA2',
    defaultMessage: 'Package',
  },
  col2_text: {
    id: 'qVGRIE',
    defaultMessage: 'Quantity',
  },
  received_text: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  connection_invalid_text: {
    id: 'DO+mh1',
    defaultMessage: 'Please provide a Connections range between 1 - 50',
  },
  sterling_headline: {
    id: 'gkL3g+',
    defaultMessage: 'IBM Sterling B2B Integration SaaS Price Estimator',
  },
  doc_invalid_text: {
    id: 'i9xtGw',
    defaultMessage: 'Please provide a Documents range between 4000 - 100,000',
  },
  book_text: {
    id: 'fkklEf',
    defaultMessage: 'Book a Consultation',
  },
  prem_tile_desc: {
    id: 'fqptqk',
    defaultMessage:
      'Managed service with a designated IBM project executive to assist you through mapping and implementation and to provide ongoing proactive support to ensure your continued success.',
  },
  slider2_text: {
    id: 'jiaMAL',
    defaultMessage: 'Total number of maps',
  },
  estimated_text1: {
    id: 'PCsOmD',
    defaultMessage: 'Estimated cost second year',
  },
  note_desc_text: {
    id: 'BRMAtz',
    defaultMessage:
      'IBM can support more than 50 direct connections, 300 maps, and 100,000 documents but a different edition may be more appropriate. Please request a quote if that is your situation',
  },
});

export default messages;
